import { z } from "zod";

export const zenDeskCategorySchema = z.object({
	id: z.number(),
	zenDeskId: z.number(),
	url: z.string().optional(),
	name: z.string(),
	description: z.string(),
	imageUrl: z.string().optional(),
});

export const zenDeskCategoriesSchema = z.array(zenDeskCategorySchema);